export const tristate = Object.freeze({
  YES: "yes",
  NO: "no",
  NA: "n/a"
});
